import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Chart, ChartOptions, Plugin } from 'chart.js/auto';

@Component({
  selector: 'aggregator-dashboard-donut-chart',
  templateUrl: './donut-chart.component.html',
  styleUrl: './donut-chart.component.scss',
  standalone: true,
  imports: [],
})
export class DashboardDonutChartComponent implements OnInit {
  @ViewChild('lineChartRef', { static: true })
  chartCanvas!: ElementRef<HTMLCanvasElement>;

  chart!: Chart;

  ngOnInit(): void {
    this.createChart();
  }

  createChart(): void {
    // Get the 2D context of the canvas
    const ctx = this.chartCanvas.nativeElement.getContext('2d');
    if (!ctx) {
      return;
    }

    // Create a new Chart instance
    this.chart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: ['Занято', 'Свободно'],
        datasets: [
          {
            label: 'Количество',
            data: [2319, 891],
            backgroundColor: ['#4caf50', '#00bcd4'],
          },
        ],
      },
      options: <ChartOptions<'doughnut'>>{
        responsive: true,
        cutout: '70%',
        plugins: {
          legend: {
            display: false,
          },
          centerTextPlugin: <ICenterTextPluginOptions>{
            text: '3210',
            color: '#231F20',
            fontSize: 28,
            subText: 'Мест',
            subTextColor: '#78828E',
            subTextFontSize: 14,
          },
        },
      },
      plugins: [CenterTextPlugin],
    });
  }
}
export const CenterTextPlugin: Plugin = {
  id: 'centerTextPlugin',

  afterDraw: (chart, args, opts) => {
    const options = opts as ICenterTextPluginOptions;

    const {
      ctx,
      chartArea: { left, top, width, height },
    } = chart;

    const mainText = options.text ?? '';
    const mainColor = options.color ?? '#000';
    const mainFontSize = options.fontSize ?? 20;
    const mainFontFamily = options.fontFamily ?? 'Arial';

    const subText = options.subText ?? '';
    const subColor = options.subTextColor ?? mainColor;
    const subFontSize = options.subTextFontSize ?? mainFontSize - 4;
    const subFontFamily = options.subTextFontFamily ?? mainFontFamily;

    if (!mainText && !subText) return;

    const centerX = left + width / 2;
    const centerY = top + height / 2;

    ctx.save();

    ctx.fillStyle = mainColor;
    ctx.font = `${mainFontSize}px ${mainFontFamily}`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    const mainOffset = subText ? -(mainFontSize * 0.3) : 0;
    ctx.fillText(mainText, centerX, centerY + mainOffset);

    if (subText) {
      ctx.fillStyle = subColor;
      ctx.font = `${subFontSize}px ${subFontFamily}`;
      const subOffset = subFontSize * 0.8;
      ctx.fillText(subText, centerX, centerY + subOffset);
    }

    ctx.restore();
  },
};

interface ICenterTextPluginOptions {
  text?: string;
  color?: string;
  fontSize?: number;
  fontFamily?: string;

  subText?: string;
  subTextColor?: string;
  subTextFontSize?: number;
  subTextFontFamily?: string;
}
